<template lang="pug">
  b-container(fluid)
    b-row
      b-col.mb-3.p-0
        GeneralMenu
    b-row.thirdPart.pb-5
      b-col(cols="3")
      b-col(cols="6")
        h2.text-center Add case-study
        div.line
        p.text-center Use the form below to contribute additional knowledge from an existing NBS case study. Submitted data will be added to the existing database and corresponding mathematical formulas will be updated to reflect these new data.<br><br>
        |  Fields noted with an asterisk are required. Please note that, while not all fields are mandatory, completion of all fields will help ensure contributed data are properly considered and incorporated. After entering all available data, select ‘Upload Case’ at the top of the page. After submitted data have been processed, a confirmation email will be provided.
      b-col(cols="3")

    b-row
      b-col
        b-alert(variant="success" v-model="showDismissibleAlert" dismissible) {{ alertText }}

    b-row.m-5
      b-col
        b-row.border-bottom.pb-2.mb-3
          b-col.p-0
            a(type="button" style="").titleText CONTACT
        b-row
          b-col(cols="6").p-0
            p.textExplain Complete this section if the data provided are Provide your contact details to receive email confirmation after processing and in case additional details are needed for the submitted case study. with a scientific publication.
        b-row
          b-col
            InputText(label="Name*", id_custom="case_name", type="text" , description="", :value="study.case_name",  @input="(val) => {study.case_name = val}")
            InputText(label="Company/Institution*", id_custom="case_company", type="text" , description="", :value="study.case_company"  @input="(val) => {study.case_company = val}")
            InputText(label="Email*", id_custom="case_email", type="text" , description="", :value="study.case_email",  @input="(val) => {study.case_email = val}")

    b-row.m-5
      b-col.mr-4
        b-row.border-bottom.pb-2.mb-3
          b-col.p-0
            a(type="button" style="").titleText Publication source
        b-row
          b-col(cols="12").p-0
            p.textExplain Complete this section if the data provided are associated with a scientific publication.
        b-row
          b-col
            InputText(label="Title", id_custom="case_journal_title", type="text" , description="", :value="study.case_journal_title" @input="(val) => {study.case_journal_title = val}")
            InputText(label="Author/s", id_custom="case_journal_author", type="text" , description="", :value="study.case_journal_authors" @input="(val) => {study.case_journal_authors = val}")
            InputText(label="Journal", id_custom="case_journal", type="text" , description="", :value="study.case_journal" @input="(val) => {study.case_journal = val}")
            InputText(label="Year", id_custom="case_journal_year", type="text" , description="", :value="study.case_journal_year"  @input="(val) => {study.case_journal_year = val}")
            InputText(label="Volume", id_custom="case_journal_volume", type="text" , description="", :value="study.case_journal_volume"  @input="(val) => {study.case_journal_volume = val}")
            InputText(label="Issue", id_custom="case_journal_issue", type="text" , description="", :value="study.case_journal_issue"  @input="(val) => {study.case_journal_issue = val}")
            InputText(label="Start page", id_custom="case_journal_start_page", type="text" , description="", :value="study.case_journal_start_page"  @input="(val) => {study.case_journal_start_page = val}")
            InputText(label="End page", id_custom="case_journal_end_page", type="text" , description="", :value="study.case_journal_end_page"  @input="(val) => {study.case_journal_end_page = val}")
            InputText(label="DOI", id_custom="case_journal_doi", type="text" , description="", :value="study.case_journal_doi"  @input="(val) => {study.case_journal_doi = val}")
            InputText(label="WOS code", id_custom="case_journal_wos", type="text" , description="", :value="study.case_journal_wos"  @input="(val) => {study.case_journal_wos = val}")
      b-col
        b-row.border-bottom.pb-2.mb-3
          b-col.p-0
            a(type="button" style="").titleText Technology
        b-row
          b-col(cols="12").p-0
            p.textExplain For cases related to treatment for a single household, select ‘household solution’. For treatment of multi-household or community-scale systems, leave this option unselected. Water and air temperature can be added in Celsius degrees. Hydraulic retention time (HRT) can be added in days. Surface area must be entered as square meters (m2). Inflow must be filled in cubic meters per day (m3/day). Population can be added in number of served inhabitants hab. The organic load can be added in persons equivalents PE.
        b-row
          b-col
            b-form-group(label-cols="4" label="Type*" label-align="left")
              b-form-select(v-model="technology.case_tech_type" :options="type_options").mb-3
            b-form-group(label-cols="4" label="Sub-type*" label-align="left")
              b-form-select(v-model="technology.case_tech_subtype" :options="subType_options").mb-3
            b-form-group(label-cols="4" label="Household solution" label-align="left")
              b-form-checkbox(v-model="technology.case_tech_uws").mb-3
            b-form-group(label-cols="4" label="Type of water" label-align="left")
              b-form-select(v-model="technology.case_tech_watertype" :options="water_type").mb-3


            InputText(label="Water temperature", id_custom="case_journal", type="number" , description="", :value="technology.case_tech_water_temp" sufix="ºC" ,  @input="(val) => {technology.case_name = val}")
            InputText(label="Air temperature", id_custom="case_journal", type="number" , description="", :value="technology.case_tech_air_temp" sufix="ºC",  @input="(val) => {technology.case_tech_air_temp = val}")
            InputText(label="HRT", id_custom="case_journal", type="number" , description="", :value="technology.case_tech_hrt" sufix="day",  @input="(val) => {technology.case_tech_hrt = val}")
            InputText(label="Surface*", id_custom="case_journal", type="number" , description="", :value="technology.case_tech_surface" sufix="m2",  @input="(val) => {technology.case_tech_surface = val}")
            InputText(label="Inflow*", id_custom="case_journal", type="number" , description="", :value="technology.case_tech_inflow" sufix="m3/day",  @input="(val) => {technology.case_tech_inflow = val}")
            InputText(label="Population", id_custom="case_journal", type="number" , description="", :value="technology.case_tech_population" sufix="hab",  @input="(val) => {technology.case_tech_population = val}")


    b-row.m-5
      b-col
        b-row.border-bottom.pb-2.mb-3
          b-col.p-0
            a(type="button" style="").titleText Specifications
        b-row
          b-col(cols="12").p-0
            p.textExplain This section is to fill the treatment performance for different compounds. The user shall introduce the inflow concentration and the effluent concentration of the studied compounds.
        b-row.mb-2
          b-col(cols= 2)
          b-col.text-center
            span.text-uppercase Influent (in)
          b-col.text-center
            span.text-uppercase Effluent (out)

        b-row
          b-col
            InputInOut(label="BOD", id_custom="case_spec_bod", type="number" , description="", :value="specifications.bod" sufix="mgO<sub>2</sub>/L",  @input="(val) => {specifications.bod = val}")
            InputInOut(label="COD", id_custom="case_spec_cod", type="number" , description="", :value="specifications.cod" sufix="mgO<sub>2</sub>/L",  @input="(val) => {specifications.cod = val}")
            InputInOut(label="TN", id_custom="case_spec_tn", type="number" , description="", :value="specifications.tn" sufix="mgN/L",  @input="(val) => {specifications.tn = val}")
            InputInOut(label="NO<sub>3</sub><sup>-</sup>N", id_custom="case_spec_no3", type="number" , description="", :value="specifications.no3" sufix="mgN/L",  @input="(val) => {specifications.no3 = val}")
            InputInOut(label="NH<sub>4</sub><sup>+</sup>-N", id_custom="case_spec_nh4", type="number" , description="", :value="specifications.nh4" sufix="mgN/L",  @input="(val) => {specifications.nh4 = val}")
            InputInOut(label="TP", id_custom="case_spec_tp", type="number" , description="", :value="specifications.tp" sufix="mgP/L",  @input="(val) => {specifications.tp = val}")
            InputInOut(label="PO<sub>4</sub><sup>3-</sup>-P ", id_custom="case_spec_po43", type="number" , description="", :value="specifications.po43" sufix="mgP/L",  @input="(val) => {specifications.po43 = val}")
            br
            br
            InputInOut(label="E.coli ", id_custom="case_spec_po43", type="number" , description="", :value="specifications.ecoli" sufix="CFU/L",  @input="(val) => {specifications.ecoli = val}")
            InputInOut(label="H.eggs ", id_custom="case_spec_po43", type="number" , description="", :value="specifications.heggs" sufix="eggs/L",  @input="(val) => {specifications.heggs = val}")
    b-row.m-5
      b-col.mr-3
        b-button.buttonStyle(squared variant="outline-primary" @click="upButton").float-right Upload Case
    //b-row
      b-col(lg="6" cols="12")
        b-row
          b-col
            b-card(title="Where to find:")
              p.littleText This section can be filled in case the offered information has been extracted from a scientific publication in a journal.
              InputText(label="Title", id_custom="case_journal_title", type="text" , description="", :value="study.case_journal_title" @input="(val) => {study.case_journal_title = val}")
              InputText(label="Author/s", id_custom="case_journal_author", type="text" , description="", :value="study.case_journal_authors" @input="(val) => {study.case_journal_authors = val}")
              InputText(label="Journal", id_custom="case_journal", type="text" , description="", :value="study.case_journal" @input="(val) => {study.case_journal = val}")
              InputText(label="Year", id_custom="case_journal_year", type="text" , description="", :value="study.case_journal_year"  @input="(val) => {study.case_journal_year = val}")
              InputText(label="Volume", id_custom="case_journal_volume", type="text" , description="", :value="study.case_journal_volume"  @input="(val) => {study.case_journal_volume = val}")
              InputText(label="Issue", id_custom="case_journal_issue", type="text" , description="", :value="study.case_journal_issue"  @input="(val) => {study.case_journal_issue = val}")
              InputText(label="Start page", id_custom="case_journal_start_page", type="text" , description="", :value="study.case_journal_start_page"  @input="(val) => {study.case_journal_start_page = val}")
              InputText(label="End page", id_custom="case_journal_end_page", type="text" , description="", :value="study.case_journal_end_page"  @input="(val) => {study.case_journal_end_page = val}")
              InputText(label="DOI", id_custom="case_journal_doi", type="text" , description="", :value="study.case_journal_doi"  @input="(val) => {study.case_journal_doi = val}")
              InputText(label="WOS code", id_custom="case_journal_wos", type="text" , description="", :value="study.case_journal_wos"  @input="(val) => {study.case_journal_wos = val}")
        b-row.mt-2
          b-col
            b-card(title="Contact:")
              p.littleText The user must fill at least his/her name and an email, this way we can get in touch with him/her in case some doubts appear when analysing the offered data.

              //InputText(label="Phone", id_custom="case_phone", type="text" , description="", :value="study.case_phone"  @input="(val) => {study.case_phone = val}")
      b-col(lg="6" cols="12")
        b-card(title="Technology:")
          p.littleText The user must specify the type of NBS and the sub-type when corresponding. The user shall click on household solution in case the data is from for a study involving a familiar household wastewater sanitation, in case the data is from treatment of larger flows (for example, from a community), he/she will leave this option unclicked. Type of water treated must be selected. Water and air temperature can be added in Celsius degrees. Hydraulic retention time HRT can be added in days. Surface area must be filled in square meters m2. Inflow must be filled in cubic meters per day m3/day. Population can be added in number of served inhabitants hab. The organic load can be added in persons equivalents PE.
          b-form-group(label-cols="4" label="Type*" label-align="left")
            b-form-select(v-model="technology.case_tech_type" :options="type_options").mb-3
          b-form-group(label-cols="4" label="Sub-type*" label-align="left")
            b-form-select(v-model="technology.case_tech_subtype" :options="subType_options").mb-3
          b-form-group(label-cols="4" label="Household solution" label-align="left")
            b-form-checkbox(v-model="technology.case_tech_uws").mb-3
          b-form-group(label-cols="4" label="Type of water" label-align="left")
            b-form-select(v-model="technology.case_tech_watertype" :options="water_type").mb-3
              

          InputText(label="Water temperature", id_custom="case_journal", type="number" , description="", :value="technology.case_tech_water_temp" sufix="ºC" ,  @input="(val) => {technology.case_name = val}")
          InputText(label="Air temperature", id_custom="case_journal", type="number" , description="", :value="technology.case_tech_air_temp" sufix="ºC",  @input="(val) => {technology.case_tech_air_temp = val}")
          InputText(label="HRT", id_custom="case_journal", type="number" , description="", :value="technology.case_tech_hrt" sufix="day",  @input="(val) => {technology.case_tech_hrt = val}")
          InputText(label="Surface*", id_custom="case_journal", type="number" , description="", :value="technology.case_tech_surface" sufix="m2",  @input="(val) => {technology.case_tech_surface = val}")
          InputText(label="Inflow*", id_custom="case_journal", type="number" , description="", :value="technology.case_tech_inflow" sufix="m3/day",  @input="(val) => {technology.case_tech_inflow = val}")
          InputText(label="Population", id_custom="case_journal", type="number" , description="", :value="technology.case_tech_population" sufix="hab",  @input="(val) => {technology.case_tech_population = val}")
          //InputText(label="Organic load", id_custom="case_journal", type="number" , description="", :value="technology.case_tech_organic_load" sufix="pe",  @input="(val) => {technology.case_tech_organic_load = val}")
      b-col(cols="12").mt-5.mb-5
        b-card(title="Specifications")
          p.littleText This section is to fill the treatment performance for different compounds. The user shall introduce the inflow concentration and the effluent concentration of the studied compounds in concentration units: milligrams per litre mg/L of biological oxygen demand BOD, chemical oxygen demand COD, total nitrogen TN, nitrates NO3-N, ammonia NH4+-N, total phosphorus TP and phosphates PO43--P, in Coliform forming units per litre CFU/L for Escherichia coli and eggs per litre eggs/L for Helminth eggs.
          InputInOut(label="BOD", id_custom="case_spec_bod", type="number" , description="", :value="specifications.bod" sufix="mgO<sub>2</sub>/L",  @input="(val) => {specifications.bod = val}")
          InputInOut(label="COD", id_custom="case_spec_cod", type="number" , description="", :value="specifications.cod" sufix="mgO<sub>2</sub>/L",  @input="(val) => {specifications.cod = val}")
          InputInOut(label="TN", id_custom="case_spec_tn", type="number" , description="", :value="specifications.tn" sufix="mgN/L",  @input="(val) => {specifications.tn = val}")
          InputInOut(label="NO<sub>3</sub><sup>-</sup>N", id_custom="case_spec_no3", type="number" , description="", :value="specifications.no3" sufix="mgN/L",  @input="(val) => {specifications.no3 = val}")
          InputInOut(label="NH<sub>4</sub><sup>+</sup>-N", id_custom="case_spec_nh4", type="number" , description="", :value="specifications.nh4" sufix="mgN/L",  @input="(val) => {specifications.nh4 = val}")
          InputInOut(label="TP", id_custom="case_spec_tp", type="number" , description="", :value="specifications.tp" sufix="mgP/L",  @input="(val) => {specifications.tp = val}")
          InputInOut(label="PO<sub>4</sub><sup>3-</sup>-P ", id_custom="case_spec_po43", type="number" , description="", :value="specifications.po43" sufix="mgP/L",  @input="(val) => {specifications.po43 = val}")
          br
          br
          InputInOut(label="E.coli ", id_custom="case_spec_po43", type="number" , description="", :value="specifications.ecoli" sufix="CFU/L",  @input="(val) => {specifications.ecoli = val}")
          InputInOut(label="H.eggs ", id_custom="case_spec_po43", type="number" , description="", :value="specifications.heggs" sufix="eggs/L",  @input="(val) => {specifications.heggs = val}")
</template>

<script>

  import InputText from './Inputs/InputText'
  import InputInOut from './Inputs/InputInOut'
  const axios = require('axios');
  import GeneralMenu from '@/components/GeneralMenu.vue'
  import * as ss from 'simple-statistics'

  Array.prototype.sum = function(){
    return this.reduce((p,c)=>(p+c),0);
  };

  export default {
    name: "CaseStudyForm",
    components:{InputText, InputInOut, GeneralMenu},
    data: function () {
      return {
        showDismissibleAlert: false,
        alertText: "",
        study:{
          case_journal_title: "",
          case_journal_authors: "",
          case_journal:"",
          case_journal_year:"",
          case_journal_volume:"",
          case_journal_issue:"",
          case_journal_start_page:"",
          case_journal_end_page:"",
          case_journal_doi:"",
          case_journal_wos:"",

          case_name:"",
          case_company:"",
          case_email:"",
          case_phone:"",
        },
        technology:{
          case_tech_type:"",
          case_tech_subtype:"",
          case_tech_uws:"",
          case_tech_watertype:"",

          case_tech_water_temp:"",
          case_tech_air_temp:"",
          case_tech_hrt:"",
          case_tech_surface:"",
          case_tech_inflow:"",
          case_tech_population:"",
          case_tech_organic_load:""
        },
        specifications:{
          bod:{input: "", output: "", percentage: ""},
          cod:{input: "", output: "", percentage: ""},
          tn:{input: "", output: "", percentage: ""},
          no3:{input: "", output: "", percentage: ""},
          nh4:{input: "", output: "", percentage: ""},
          tp:{input: "", output: "", percentage: ""},
          po43:{input: "", output: "", percentage: ""},
          ecoli:{input: "", output: "", percentage: ""},
          heggs:{input: "", output: "", percentage: ""}
        },
        type_options: [
          { value: "", text: 'Please select an option' },
          { value: "CW", text: 'Constructed wetlands' },
          { value: "GR", text: 'Green Roof' },
          { value: "GW", text: 'Green Wall' },
          { value: "MS", text: 'Multi Stage' },
          { value: "HA", text: 'Hydroponics/Aquaponics' },
          { value: "I-SRS", text: 'In-stream retention systems ' },
          { value: "NW", text: 'Natural Wetlands' },
          { value: "PL", text: 'Ponds/Lagoons' },
          { value: "SIS", text: 'Soil infiltration systems' },
          { value: "WS", text: 'Willow systems' }
        ],
        water_type:[
          {value: "", text: 'Please select an option'},
          {value: "Raw domestic wastewater", text: 'Raw domestic wastewater'},
          {value: "Pretreated domestic wastewater", text: 'Pretreated domestic wastewater'},
          {value: "Greywater", text: 'Greywater'},
          {value: "Secondary treated wastewater", text: 'Secondary treated wastewater'},
          {value: "CSO discharge wastewater", text: 'CSO discharge wastewater'},
          {value: "River diluted wastewater", text: 'River diluted wastewater'},
        ],
        study_clean: "",
        technology_clean: "",
        specifications_clean: "",
      }
    },
    mounted() {
      this.study_clean = JSON.stringify(this.study)
      this.technology_clean = JSON.stringify(this.technology)
      this.specifications_clean = JSON.stringify(this.specifications)
    },
    computed:{
      subType_options: function () {
          switch (this.technology.case_tech_type) {
            case "CW":
              return [
                { value: "", text: 'Please select an option' },
                { value: "CSO_CW", text: 'CSO' },
                { value: "French_CW", text: 'French configuration' },
                { value: "VSSF_CW", text: 'Vertical' },
                { value: "HSSF_CW", text: 'Horizontal' },
                { value: "FWS_CW", text: 'Free water surface' },
                { value: "IRM_CW", text: 'Intensified reactive media' },
                { value: "IA_CW", text: 'Intensified aeration' },
                { value: "R_CW", text: 'Recirculation' },
                ];
            case "GR":
              return [
                { value: "", text: 'Green Roof' },
              ];
            case "GW":
              return [
                { value: "", text: 'Green Wall' },
              ];
            case "HA":
              return [
                { value: "", text: 'Please select an option' },
                { value: "A_HA", text: 'Aquaponics' },
                { value: "H_HA", text: 'Hydroponics' },
              ];
            case "I-SRS":
              return [
                { value: "", text: 'In-stream retention systems ' },
              ];
            case "NW":
              return [
                { value: "", text: 'Natural Wetlands' },
              ];
            case "PL":
              return [
                { value: "", text: 'Please select an option' },
                { value: "IA_PL", text: 'Intensified aerated ' },
                { value: "AP_PL", text: 'Anaerobic' },
                { value: "FP_PL", text: 'Facultative' },
                { value: "MP_PL", text: 'Maturation' },
              ];
            case "SIS":
              return [
                { value: "", text: 'Please select an option' },
                { value: "SIS_R", text: 'Rapid' },
                { value: "SIS_S", text: 'Slow' },
              ];
            case "WS":
              return [
                { value: "", text: 'Willow systems' },
              ];
            case "MS":
              return [
                { value: "", text: 'Please select an option' },
                { value: "VSSF+HSSF_CW", text: 'Vertical CW followed by horizontal CW' },
                { value: "HSSF_CW+MP_PL", text: 'Horizontal CW followed by maturation pond'},
                { value: "AP+FP_PL", text: 'Anaerobic pond followed by facultative pond ' },
                { value: "AP+FP+MP_PL", text: 'Anaerobic pond followed by facultative pond followed by maturation pond ' },
                { value: "FP+MP_PL", text: 'Facultative pond followed by maturation pond ' },
                { value: "FP_P/L+FWS_CW", text: 'Facultative pond followed by free water surface constructed wetland' },
              ];

            default:
              return [{ value: "", text: 'Select type first' }];
          }
      }
    },
    methods:{
      recursiveReset(obj) {
        let _this = this
        Object.keys(obj).map(key => {
          // Test if it's an Object
          if (obj[key] === Object(obj[key])) {
            _this.recursiveReset(obj[key])
            return
          }
          if (obj[key] instanceof Array) obj[key] = []
          else obj[key] = ""
        })
      },
      checkSpecifications(cont){
        // specifications:{
        //   bod:{input: "", output: "", percentage: ""},
        //   cod:{input: "", output: "", percentage: ""},
        //   tn:{input: "", output: "", percentage: ""},
        //   no3:{input: "", output: "", percentage: ""},
        //   nh4:{input: "", output: "", percentage: ""},
        //   tp:{input: "", output: "", percentage: ""},
        //   po43:{input: "", output: "", percentage: ""},
        //   ecoli:{input: "", output: "", percentage: ""},
        //   heggs:{input: "", output: "", percentage: ""}
        // }

        if(this.specifications[cont].input === "" && this.specifications[cont].output === ""){
          return {error: false, text: "No input" + cont}
        }
        if(this.specifications[cont].input === "" && this.specifications[cont].output !== ""){
          return {error: true, text: "The specification field "+cont+" need Input and output"}
        }
        else if(this.specifications[cont].output === "" && this.specifications[cont].input !== ""){
          return {error: true, text: "The specification field "+cont+" need Input and output"}
        }
        else if(this.specifications[cont].input < 0){
          return  {error: true, text: "The specification field "+cont+", Input is a negative value."}
        }
        else if(this.specifications[cont].output <= 0){
          return  {error: true, text: "The specification field "+cont+", Input is a negative value."}
        }
        if(this.specifications[cont].input < this.specifications[cont].output )
          return  {error: true, text: "The specification field "+cont+", Output is bigger than input"}
        return {error: false, text: ""}

      },
      upButton(){

        console.log(this.checkSpecifications('bod'));
        let _this = this;
        let contaminantList = ['bod','cod','ecoli','heggs','nh4','no3','po43','tn','tp'];
        let error = {error: false};

        if(_this.study.case_name === "") {
          error = {error: true,text: "The contact name field is empty. Please fulfill all contact data."};
        }
        else if(_this.study.case_company === "") {
          error = {error: true, text: "The contact company/institution field is empty. Please fulfill all contact data."};
        }
        else if(_this.study.case_email === "") {
          error = {error: true, text: "The contact email field is empty. Please fulfill all contact data."};
        }
        else if(_this.technology.case_tech_inflow === "" && _this.technology.case_tech_population === "" ) {
          error = {error: true, text: "Fill inflow. This field is needed."};
        }
        else if(_this.technology.case_tech_inflow !== "" && _this.technology.case_tech_inflow < 0){
          error = {error: true, text: "The inflow field is a negative value."}
        }
        else if(_this.technology.case_tech_surface === "") {
          error = {error: true, text: "The surface field is empty. This field is needed."};
        }
        else if(_this.technology.case_tech_surface < 0){
          error = {error: true, text: "The surface field is a negative value."}
        }
        else if(_this.technology.case_tech_population !== "" && _this.technology.case_tech_population < 0){
          error = {error: true, text: "The population field is a negative value."}
        }

        if(!error.error) {
          for (let i = 0; i < contaminantList.length; i++) {
            if(!error.error) {
              error = this.checkSpecifications(contaminantList[i]);
            }
          }
        }

        if(error.error){
          _this.alertText = error.text;
          _this.showDismissibleAlert = true;
        }
        else {
          //axios.post('http://localhost:3000/',
          axios.post('https://snappAPI.icradev.cat/',
              {
                study: _this.study,
                technology: _this.technology,
                specifications: _this.specifications,
              }
          ).then(function (response) {
            console.log(response.data.result)
            _this.showDismissibleAlert = true;
            _this.alertText = response.data.result;

            if(response.data.result){
              _this.recursiveReset(_this.study)
              _this.recursiveReset(_this.technology)
              _this.recursiveReset(_this.specifications)
            }
          })
        }
      },
      uploadButton() {

        let _this = this;
        axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
        //axios.defaults.headers.common['Authorization'] = `Bearer ${store.state.token}`;

        axios.get('http://localhost:3000/')
          .then(function (response) {
            // handle success
            let arrayRes = JSON.parse(response.data.result);
            console.log("raw array:",arrayRes);
            let arrayXY = arrayRes.map(p=>{ return {"code_cs":p.code_cs ,"x":p.surface, "y":(p.bod_in*p.inflow)-(p.bod_out*p.inflow)}});

            arrayXY = arrayXY.filter(p=>{return p.x > 0}); //discard 0 on surface
            console.log(arrayXY);

            //Linear
            let arrayXYFiltered = arrayXY.filter(p=>{return true});
            console.log(arrayXYFiltered);
            console.log("Lineal: ",_this.compute_linear_regression(arrayXYFiltered));

            //Squared
            let arrayXYSquared = arrayXY.filter(p=>{return (p.y > 0)});
            arrayXYSquared = arrayXYSquared.map(p=>{return {"code":p.code_cs, "x":Math.log(p.x), "y": Math.log(p.y)}});
            console.log(arrayXYSquared);
            let squarePRegression = _this.compute_linear_regression(arrayXYSquared);
            console.log(squarePRegression);
            squarePRegression = {m: squarePRegression.m.value, n:Math.exp(squarePRegression.n.value), r_2:squarePRegression.r_2.value};
            console.log("Squared: ",squarePRegression);

            //exponential
            arrayXY = arrayRes.map(p=>{ return {"code_cs":p.code_cs ,"x":p.surface, "y":(p.bod_out*p.inflow)/(p.bod_in*p.inflow)}});
            arrayXY = arrayXY.filter(p=>{return p.x > 0}); //discard 0 on surface
            let arrayXYExponential = arrayXY.filter(p=>{return (p.y > 0)});
            arrayXYExponential = arrayXYExponential.map(p=>{return {"code":p.code_cs, "x":p.x, "y": Math.log(p.y)}});
            console.log(arrayXYExponential);
            let exponentialPRegression = _this.compute_linear_regression(arrayXYExponential);
            console.log(exponentialPRegression);
            exponentialPRegression = {m: exponentialPRegression.m.value, n:Math.exp(exponentialPRegression.n.value), r_2:exponentialPRegression.r_2.value};
            console.log("Exponential: ",exponentialPRegression);
          })
          .catch(function (error) {
            // handle error
            console.log(error);
          })
          .then(function () {
            // always executed
          });
      },
      compute_linear_regression(arrayXY){
        let xi    = arrayXY.map(p=>Number(p.x));              //x points
        let yi    = arrayXY.map(p=>Number(p.y));              //y points
        let xi_sq = xi.map(p=>Math.pow(p,2));                 //x squared points
        let yi_sq = yi.map(p=>Math.pow(p,2));                 //y squared points
        let xiyi  = arrayXY.map(p=>{                          //x·y points
          return (p.x*p.y);
        });
        let N = arrayXY.length;                               //number of points

        let xi_sum    = xi.sum();
        let yi_sum    = yi.sum();
        let xi_sq_sum = xi_sq.sum();
        let yi_sq_sum = yi_sq.sum();
        let xiyi_sum  = xiyi.sum();

        //compute m and b (y = mx + n)
        let m = (N*(xiyi_sum) - yi_sum*xi_sum)/(N*xi_sq_sum - Math.pow(xi_sum,2));
        let n = (yi_sum - m*xi_sum)/N;

        //compute r (correlation)
        let r_2 = Math.pow(N*xiyi_sum - xi_sum*yi_sum, 2)/((N*xi_sq_sum - Math.pow(xi_sum,2))*(N*yi_sq_sum - Math.pow(yi_sum,2)));

        return {
          m:{value:m},
          n:{value:n},
          r_2:{value:r_2},
        };
      }
    }

  }
</script>

<style scoped>

  .buttonStyle{
    border-color: #00ACE5 !important;
    color: #00ACE5 !important;

    padding: 10px 30px;

    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 126.5%;
    /* or 20px */

    text-align: center;
    text-transform: uppercase;
  }

  .buttonStyle:hover{
    border-color: #00ACE5 !important;
    background-color: #00ACE5 !important;
    color: white !important;
  }

  .titleText{
    /* H3 */

    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 26px;
    /* identical to box height, or 130% */

    text-transform: uppercase;

    color: #5E686D;
  }

  .textExplain{
    /* text */

    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    /* or 150% */


    color: #5E686D;
  }

  .thirdPart{
    color: white;
    background: linear-gradient(267.47deg, #BDE4F7 -89.5%, #00ACE5 96.26%);
    padding-left: 80px;
    padding-right: 80px;
  }
  .thirdPart h2{
    margin-top: 95px;
    margin-bottom: 35px;
    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    line-height: 43px;
    text-align: center;
  }
  .thirdPart .third-text{
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 26px;
  }

  .thirdPart .line{
    width: 307px;
    border: 1px solid #FFFFFF;
    margin-left: auto;
    margin-bottom: 82px;
    margin-right: auto;
  }

  label {
    display: inline-block;
    width: 100px;
  }
  fieldset{
    vertical-align: top;
  }
  .margin-left-label{
    margin-left: 14px;
  }
  .input-short{
    width: 10%;
  }
</style>